import React from 'react';
import PowerAppSolutionChangeTask from '../ManageCenter/PowerAppSolutionChangeTask';

const PowerAppSolutionTasks = ({app, refresh}) => {

    const powerAppChangeTasks = app.changeTasks.map(t =>
        <div key={t.id} style={styles.taskDivStyle}>
            <PowerAppSolutionChangeTask
                change={t}
                refresh={refresh}
                created={t.requestDate}
            />
        </div>
    )

    const tasks = [...powerAppChangeTasks]

    return (
            <div style={{ padding: '20px 20px 20px 20px', maxWidth: "680px", minWidth: "380px"}}>
                <div style={{ display: "flex", flexWrap: "wrap", marginLeft: "20px" }}>
                    {tasks}
                </div>
            </div>
    )
}

const styles = {
    taskDivStyle: {
        flex: "1",
        width: "50%",
        display: "flex",
        justifyContent: "center"
    }
}

export default PowerAppSolutionTasks;


// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppSolutionTasks.js